export const RoutingConfig: object = {
  /**
   * Defines the routing paths.
   */
  routing: {
    routes: {
      home: {paths: ['search']},
      product: {
        paths: ['product/:productCode/:name', 'product/:productCode'],
        paramsMapping: {name: 'slug'},
      },
      cart: {paths: ['cart']},
      checkoutDataEntry: {paths: ['checkout/data-entry']},
      configuratorError: {paths: ['configurator/error/:errorCode']},
      configuratorErrorDefault: {paths: ['configurator/error']},
      checkoutReviewOrder: {paths: ['checkout/review-order']},
      orderConfirmation: {paths: ['order-confirmation']},
      configurator: {paths: ['configurator']},
      category: {disabled: true},
      search: {paths: ['search/:query', 'search']},
    },
  },
};
